/** @flow */

import type { State } from "@store/reducers";
import type { FocusListsType } from "@modules/reporting/reducer/focus-lists/types";
import type {
  EmployeeReport,
  ReportCharts,
  ReportData,
  ReportState,
} from "@modules/reporting/reducer/focus-lists/employee/types";

export type GetReportDetails = (state: State) => EmployeeReport;
export type GetReportCharts = (state: State) => ReportCharts;

export const getEmployeeFocusLists = (state: State): $PropertyType<FocusListsType, "employee"> =>
  state.reporting.focusLists.employee;

export const getReport = (state: State): ReportState => getEmployeeFocusLists(state).report;

export const getReportData = (state: State): ReportData[] => getReport(state).reportData || [];

export const getCharts = (state: State): ReportCharts => getReport(state).charts;

export const getReportDetails = (state: State): ?EmployeeReport => getReport(state).details;

export const isLoading = (state: State): boolean =>
  state.reporting.focusLists.employee.report.requestsInProgress > 0;

export const isReportGenerateInProgress = (state: State): boolean => {
  return state.reporting.focusLists.employee.report.requestsInProgress > 0;
};
